// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.endpoint-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.endpoint-header-category {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.endpoint-header-title {
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  color: rgba(0, 0, 0, 0.88);
  margin: 0 !important;
}

.endpoint-header-description {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/EndPointSection/components/EndpointHeader/EndpointHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":[".endpoint-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.endpoint-header-category {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.45);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.endpoint-header-title {\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  color: rgba(0, 0, 0, 0.88);\n  margin: 0 !important;\n}\n\n.endpoint-header-description {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.65);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
